"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _FillTextEffect2 = _interopRequireDefault(require("./FillTextEffect"));

var _Color = _interopRequireDefault(require("../../../models/Color"));

var _text = require("../../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_BOX_FILL_VALUES = _text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.BOX_FILL];

var BoxFillTextEffect = /*#__PURE__*/function (_FillTextEffect) {
  (0, _inherits2["default"])(BoxFillTextEffect, _FillTextEffect);

  var _super = _createSuper(BoxFillTextEffect);

  function BoxFillTextEffect() {
    (0, _classCallCheck2["default"])(this, BoxFillTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BoxFillTextEffect, null, [{
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      var lines = contentFrameData.textLines,
          textRenderProperties = contentFrameData.textRenderProperties;
      var renderedFontSize = textRenderProperties.renderedFontSize,
          textEffect = textRenderProperties.textEffect,
          padding = textRenderProperties.padding,
          wrapProperties = textRenderProperties.wrapProperties;
      var alignmentY = this.getAlignmentY(contentFrameData);
      var horizontalPadding = this.getHorizontalPadding(renderedFontSize);
      var opacity = textEffect.get('opacity') / 100;

      var _this$getFillTextProp = this.getFillTextProperties(lines, padding + horizontalPadding),
          lineFillWidth = _this$getFillTextProp.lineFillWidth,
          lineFillX = _this$getFillTextProp.lineFillX;

      var boxFillX = Math.min(lineFillX, 0);
      var wrapWidth = wrapProperties.get('width') - boxFillX;
      var boxWidth = Math.max(lineFillWidth, wrapWidth);
      var firstLine = lines[0];
      var fontBoundingBoxAscent = firstLine.fontBoundingBoxAscent,
          fontHeight = firstLine.fontHeight,
          firstY = firstLine.y;
      var firstLineY = alignmentY + firstY;
      var boxFillY = Math.min(firstLineY - fontBoundingBoxAscent - padding, 0);
      var boxHeight = Math.max(fontHeight * lines.length + 2 * padding, wrapProperties.get('height')); // draw box
      // draw line fill boxes in to a separate canvas

      var fillColor = textEffect.get('color') || DEFAULT_BOX_FILL_VALUES.color;
      finalContext.fillStyle = _Color["default"].getColorFromHexColor(fillColor, opacity);
      this.fillRect(finalContext, boxFillX, boxFillY, boxWidth, boxHeight, textEffect.get('borderRadius')); // draw text over

      finalContext.fillStyle = textRenderProperties.fillColor;
      this.drawTextLines(finalContext, contentFrameData);
    }
  }]);
  return BoxFillTextEffect;
}(_FillTextEffect2["default"]);

exports["default"] = BoxFillTextEffect;